/**
 * CountPill — small "12 found" style result-count badge (course search
 * results, filtered lists). Purely presentational.
 */
import { cn } from '@/lib/utils';

export interface CountPillProps {
  count: number;
  /** Word following the count. Defaults to "found". */
  noun?: string;
  className?: string;
}

export function CountPill({
  count,
  noun = 'found',
  className,
}: CountPillProps) {
  return (
    <span
      className={cn(
        // whitespace-nowrap + shrink-0: next to a truncating panel title the
        // pill is the flex row's squeeze victim and "5 found" wraps into two
        // lines on phones (FB26).
        "inline-flex shrink-0 items-center whitespace-nowrap rounded-[20px] bg-[#F6EEE3] px-[11px] py-1 font-['Work_Sans'] text-[12px] font-semibold text-[#8a7c68]",
        className
      )}
    >
      {count} {noun}
    </span>
  );
}
